import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { MaterialModule } from '../common-modules/material.module';
import { CommentBoxComponent } from '../components/comment-box/comment-box.component';
import { ErrorMessageComponent } from '../components/error-message/error-message.component';
import { AmountCalculationDirective } from './directives/amount-calculation.directive';
import { DisableControlDirective } from './directives/disableControl/disable-control.directive';
import { NumberFormatDirective } from './directives/numberFormat/number-format.directive';
import { NumericDirective } from './directives/numeric/numeric.directive';
import { PostalCodeFormatDirective } from './directives/postalCodeFormat/postal-code-format.directive';
import { ProductHoverDirective } from './directives/product-hover/product-hover.directive';
import { SetFocusDirective } from './directives/set-focus/set-focus.directive';
import { StopPropagationDirective } from './directives/stop-propagation/stop-propagation.directive';
import { ShowIfTruncatedDirective } from './directives/truncated-text-tooltip/show-if-truncated.directive';
import { ValidateOnBlurDirective } from './directives/validate-on-blur/validate-on-blur.directive';
import { PipesModule } from './pipes/pipes.module';

import { StackedBarComponent } from './component/stacked-bar/stacked-bar.component';
import { WatermarkComponent } from '../components/watermark/watermark.component';

@NgModule({
    declarations: [
        WatermarkComponent,
        ErrorMessageComponent,
        CommentBoxComponent,
        ProductHoverDirective,
        NumericDirective,
        StopPropagationDirective,
        ValidateOnBlurDirective,
        SetFocusDirective,
        NumberFormatDirective,
        ShowIfTruncatedDirective,
        AmountCalculationDirective,
        DisableControlDirective,
        PostalCodeFormatDirective
        
    ],
    imports: [
        CommonModule,
        MaterialModule,
        NgxMatSelectSearchModule,
        PipesModule,
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        NgxPageScrollCoreModule,
        StackedBarComponent
    ],
    exports: [
        PipesModule,
        TooltipModule,
        PopoverModule,
        FormsModule,
        TranslateModule,
        ReactiveFormsModule,
        ErrorMessageComponent,
        CommentBoxComponent,
        NgxMatSelectSearchModule,
        ProductHoverDirective,
        NumericDirective,
        StopPropagationDirective,
        SetFocusDirective,
        ValidateOnBlurDirective,
        NumberFormatDirective,
        ShowIfTruncatedDirective,
        AmountCalculationDirective,
        DisableControlDirective,
        PostalCodeFormatDirective,
        StackedBarComponent,
        WatermarkComponent
    ],
    providers: []
})

export class SharedModule {
}
